// Jev window (2026-10-07) — gate predicate for the header "🧠 Jev" button, the
// live viewer of the blackout-dates Lambda's Jev shadow-mode log.
//
// Returns true ONLY when the user is logged in AND their Users document's
// `screenAccessList` contains the `"jev"` token (managed in UserDetailModal →
// Tab Access, like "compass"). Strict `.includes(token)`, same rationale as
// canAccessCompass. The query behind the window ALSO checks the token
// server-side (convex/lib/screenAccess.ts), so this predicate only hides the UI.

export function canAccessJev(mongoUser, tsUserDocument) {
  return (
    Boolean(mongoUser) &&
    Array.isArray(tsUserDocument?.screenAccessList) &&
    tsUserDocument.screenAccessList.includes("jev")
  );
}
